/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

console.log('Hello World from Webpacker')
import '@babel/polyfill';
import 'src/scss/home.scss'
import 'src/scss/pages.scss'
import 'src/scss/_utilities.scss';
import 'channels/responses_channel.js';
import 'src/js/application/convince.js';
import 'src/js/application/index.js';
import '../images/arrow-button.svg';
